import type { AxiosInstance } from 'axios';
import type {
  InspectionCheck,
  InspectionListQueryParams,
  InspectionCheckUpdateRequest,
  EntityId,
  PaginatedInspectionChecksResponse,
} from '@/types';

export const getInspectionChecks = async (
  api: AxiosInstance,
  inspection_id: EntityId,
  document_id: EntityId | undefined = undefined,
  manifest_id: EntityId | undefined = undefined,
  limit = 50,
  start_key: string | undefined = undefined,
  name: string | undefined = undefined,
): Promise<PaginatedInspectionChecksResponse> => {
  const resp = await api.get<PaginatedInspectionChecksResponse>(
    `/inspection/${inspection_id}/check`,
    {
      params: {
        document_id,
        manifest_id,
        limit,
        start_key,
        name,
      } as InspectionListQueryParams,
    },
  );
  return resp.data;
};

export const getInspectionCheck = async (
  api: AxiosInstance,
  inspection_id: EntityId,
  inspection_check_id: EntityId,
): Promise<InspectionCheck> => {
  const resp = await api.get<InspectionCheck>(
    `/inspection/${inspection_id}/check/${inspection_check_id}`,
  );
  return resp.data;
};

export const updateInspectionCheck = async (
  api: AxiosInstance,
  inspection_id: EntityId,
  inspection_check_id: EntityId,
  values: InspectionCheckUpdateRequest,
): Promise<InspectionCheck> => {
  const resp = await api.put<InspectionCheck>(
    `/inspection/${inspection_id}/check/${inspection_check_id}`,
    values,
  );
  return resp.data;
};
